export default {
  PhotoReview: {
    queued: { Text: 'Wartet auf Prüfung' },
    reviewed: { Text: 'Überprüft' },
  },
  PhotoRating: {
    pending: {
      Text: 'Ausstehende Überprüfung',
      Description: 'Verfügbar für die meisten Nutzer (die Safe Browsing deaktiviert haben)',
    },
    public: {
      Text: 'Öffentlich',
      Description: 'Für alle verfügbar',
    },
    'public-sensitive': {
      Text: 'Öffentlich',
      Description: 'Verfügbar für die meisten Nutzer (die Safe Browsing deaktiviert haben)',
    },
    banned: {
      Text: 'Verbotener Inhalt',
      Description: 'Zur Löschung markiert',
    },
    private: {
      Text: 'Privat',
      Description: 'Nur für Nutzer verfügbar, denen du Zugriff gewährt hast',
    },
    message: {
      Text: 'Nachrichten-Element',
      Description: 'Nur für den Empfänger',
    },
    other: {
      Text: 'Unbekannt',
      Description: '',
    },
  },
  Community: {
    default: {
      TextField1: 'Beruf',
      TextField2: 'Bildung',
      TextField3: 'Interessen',
    },
    ferzu: {
      TextField1: 'Meine Fursona',
      TextField2: 'Beruf / Bildung',
      TextField3: 'Interessen',
    },
    pupspace: {
      TextField1: 'Meine Hobbys',
      TextField2: 'Meine Kinks und Ausrüstung',
      TextField3: 'Meine Grenzen und Gesundheit',
    },
  },
  CommunityCategories: {
    fandomsRoleplay: { Name: 'Fandoms und Rollenspiel' },
    plusSize: { Name: 'Plus-Size' },
    menInterestedInMen: { Name: 'Männer, die an Männern interessiert sind' },
  },
  CommunityInfo: {
    headings: {
      about: 'Über {{communityName}}',
      whatYouCanDo: 'Was du auf {{communityName}} tun kannst',
      rules: 'Unsere Community-Regeln',
      welcome: 'Willkommen bei {{communityName}}',
    },
    communities: {
      grommr: {
        caption: 'Gainer & Encourager (schwul)',
        description:
          'Eine Gainer-Encourager-Community für schwule und bisexuelle Männer, die Körperpositivität, Wachstum, Inklusion und Akzeptanz feiert.',
        sections: {
          about:
            'Grommr dient seit 2011 stolz der Gainer-Encourager-Community für schwule und bisexuelle Männer. Die Grommr-Community vereint eine vielfältige Gruppe von Männern aus aller Welt, die eines gemeinsam haben – die Überzeugung, dass größer besser ist.\n\nGrommr bietet ein inklusives Forum, in dem sich unsere Community verbinden, austauschen und gedeihen kann. Wir koordinieren außerdem regelmäßige lokale Treffen (GrommOffs) und organisieren größere halbjährliche Konferenzen, wie The Grom und EuroGrom.\n\nWir sind nicht das erste Netzwerk, das der Gainer-Encourager-Community dient, die sich bereits seit den 1980ern vernetzt. Um mehr über die Geschichte dieser großartigen, körperpositiven Community zu erfahren, sieh dir das <a href="https://www.grommr.com/Home/Community">Gainer History Project</a> an.',
          whatYouCanDo:
            ' • Durchsuche den Newsfeed, poste, kommentiere und diskutiere mit.\n • Erkunde Profile in deiner Nähe oder suche nach Mitgliedern mit ähnlichen Interessen.\n • Starte Chats mit neuen Kontakten oder alten Freunden.\n • Teile deine Fotos oder sieh dir aktuelle Fotos anderer Mitglieder an.\n • Erfahre von Gainer-Community-Events in deiner Nähe.',
          rules:
            'Wir bemühen uns, Grommr zu einem einladenden Zuhause für alle Mitglieder zu machen. Illegale Aktivitäten, Trolling, Belästigung, Rassismus, Misogynie, Homophobie, Transphobie, Ableismus sowie öffentliche Zurschaustellung von Nacktheit oder sexuellen Handlungen sind auf Grommr streng verboten.',
          welcome:
            'Wenn unser Admin-Team dir helfen kann, zögere nicht, ein Support-Ticket zu eröffnen oder uns eine E‑Mail zu senden.\n\nWillkommen!\n\nDas Grommr-Team',
        },
      },
      feabie: {
        caption: 'Feedism & BBW',
        description:
          'Eine Feedism-Community für alle, die Körperpositivität, Wachstum, Inklusion und Akzeptanz feiert.',
        sections: {
          about:
            'Feabie bietet eine inklusive Umgebung, in der sich Mitglieder der Feedism-Community – unabhängig von ihrer Orientierung – verbinden können, sei es für einen Chat, ein Date oder ein Community-Event. Willkommen sind Feedists, Fat Admirers, BBW/BHM und alle, die sich auf Feabie zu Hause fühlen.\n\nNeben unserer Online-Community organisiert Feabie auch FeabieMeets – eine Reihe lokaler Treffen, die eine vielfältige Gruppe von Feabie-Mitgliedern zusammenbringen.\n\nFeabie ist das größte soziale Netzwerk für die Feedism-Community und eines der größten körperpositiven Netzwerke der Welt.',
          whatYouCanDo:
            ' • Durchsuche den Newsfeed, poste, kommentiere und diskutiere mit.\n • Erkunde Profile in deiner Nähe oder suche nach Mitgliedern mit ähnlichen Interessen.\n • Starte einen Chat und verabrede ein Date – oder triff dich mit Freunden.\n • Teile deine Fotos oder sieh dir aktuelle Fotos anderer Mitglieder an.\n • Erfahre von Feedism-Community-Events in deiner Nähe.',
          rules:
            'Unsere Admins arbeiten hart daran, Feabie so inklusiv und einladend wie möglich zu halten. Illegale Aktivitäten, Trolling, Belästigung, Rassismus, Misogynie, Homophobie, Transphobie, Ableismus sowie öffentliche Zurschaustellung von Nacktheit oder sexuellen Handlungen sind auf Feabie streng verboten.',
          welcome:
            'Unsere Admins sind für dich da! Wenn du eine Frage oder ein Anliegen hast, zögere nicht, ein Support-Ticket zu eröffnen oder uns eine E‑Mail zu senden.\n\nWillkommen!\n\nDas Feabie-Team',
        },
      },
      chasabl: {
        caption: 'Bären, Chubs & Chaser (schwul)',
        description:
          'Eine Chub-Bear-Community für schwule und bisexuelle Männer, die Körperpositivität, Inklusion und Akzeptanz feiert.',
        sections: {
          about:
            'Chasable ist seit 2013 das größte soziale Netzwerk für die Chub-Bear-Community. Seither hat sich Chasable einen Ruf als einladende Umgebung für schwule und bisexuelle Männer aller Größen, Formen und Farben erworben. Willkommen sind Chubs, Bären, Chaser und alle dazwischen.\n\nObwohl es zahlreiche Dating-Apps für die Chub-Bear-Community gibt, bietet keine andere App die sozialen Funktionen von Chasable. Der Chasable-Newsfeed ist ein wichtiger Dreh- und Angelpunkt für Diskussionen, Fototeilen und Unterstützung.\n\nChasable unterstützt regelmäßig große Chub-Bear-Events wie Tidal Wave in Orlando und BGMO-Barabende in New York und hilft, Chub-Bear-Events weltweit zu fördern.',
          whatYouCanDo:
            ' • Erkunde Männer in deiner Nähe oder suche nach Chubs, Bären und Chasern mit ähnlichen Interessen.\n • Teile deine Fotos oder sieh dir aktuelle Fotos anderer Mitglieder an.\n • Durchsuche den Newsfeed, poste, kommentiere und diskutiere mit.\n • Sende einen Flirt, starte einen Chat mit einem neuen Kontakt oder triff dich mit Freunden.\n • Erfahre von Chub-Bear-Events in deiner Nähe.',
          rules:
            'Die Admins von Chasable helfen, unsere Community für alle zu einem sicheren Ort zu machen. Illegale Aktivitäten, Trolling, Belästigung, Rassismus, Misogynie, Homophobie, Transphobie, Ableismus sowie öffentliche Zurschaustellung von Nacktheit oder sexuellen Handlungen sind auf Chasable streng verboten.',
          welcome:
            'Du hast Fragen? Siehst du etwas, das nicht auf Chasable gehört? Unser Admin-Team hilft dir gerne! Öffne jederzeit ein Support-Ticket oder sende uns eine E‑Mail.\n\nWillkommen!\n\nDas Chasable-Team',
        },
      },
      ferzu: {
        caption: 'Furries & Anthros',
        description:
          'Eine Furry-Community für alle, die das Furry-Fandom, Furry-Kunst und Inklusion feiert.',
        sections: {
          about:
            'Ferzu ist das größte soziale Netzwerk, das dem Furry-Fandom gewidmet ist. Ob deine Fursona läuft, fliegt oder schwimmt, ob du hetero oder LGBTQ bist, mollig oder schlank, Streifen oder Punkte – auf Ferzu findest du ein inklusives Zuhause.\n\nWir sind stolz darauf, einen sicheren Raum zu bieten, in dem sich alle Furries verbinden und gedeihen können. Oft finden auf Ferzu Gespräche statt, die auf trollfreundlicheren Mainstream-Plattformen nie stattfinden würden.',
          whatYouCanDo:
            ' • Durchsuche den Newsfeed, poste, kommentiere und diskutiere mit.\n • Sieh dir die neueste Furry-Kunst an und teile deine eigene.\n • Erkunde Profile in deiner Nähe oder suche nach Furries mit ähnlichen Interessen.\n • Starte Chats mit neuen Kontakten oder alten Freunden.\n • Erfahre von Furry-Conventions, sieh, wer teilnimmt, und mach mit.',
          rules:
            'Ferzu ist ein sicherer Raum für alle Furries. Daher sind Trolling, Belästigung, Rassismus, Misogynie, Homophobie, Transphobie, Ableismus sowie öffentliche Zurschaustellung von Nacktheit oder sexuellen Handlungen streng verboten.\n\nUns liegen auch die Künstler am Herzen, die das Rückgrat unserer Community bilden. Daher setzen unsere Admins strenge Richtlinien zum Schutz von Furry-Kunst durch.',
          welcome:
            'Unser Admin-Team steht dir jederzeit zur Verfügung, um deine Fragen zu beantworten oder dir bei Problemen auf Ferzu zu helfen. Wenn du etwas brauchst, zögere nicht, ein Support-Ticket zu eröffnen oder uns eine E‑Mail zu senden.\n\nEin großes, pelziges Willkommen!\n\nDas Ferzu-Team',
        },
      },
      pupspace: {
        caption: 'Menschliche Pups & Handler',
        description:
          'Eine neue Pup-Play-Community für menschliche Pups, Handler und alle, die es lieben, in den Pup-Headspace zu kommen.',
        sections: {
          about:
            'Pupspace ist das erste soziale Netzwerk und die erste App, die der Puppy-Play-Community und unseren Freunden gewidmet ist. Mitglieder aller Geschlechter, Identitäten und Hintergründe sind willkommen.\n\nWir möchten eine inklusive und fördernde Community für alle Mitglieder aufbauen – unabhängig davon, wie du dich identifizierst, wo du lebst oder ob du in einer Beziehung bist. Pupspace ist ein sicherer Ort, an dem Mitglieder frei erkunden, sie selbst sein, in den Pup-Headspace kommen und ihren inneren Pup entfesseln können.',
          whatYouCanDo:
            '• Durchsuche den Newsfeed, poste, kommentiere und diskutiere mit anderen Pups und Handlern.\n• Erkunde Profile in deiner Nähe oder suche nach Pups mit ähnlichen Interessen.\n• Starte einen Chat, verabrede ein Playdate oder triff dich einfach mit Freunden.\n• Teile deine Fotos oder sieh dir aktuelle Fotos anderer Pups an.\n• Erfahre von Puppy-Events und Moshes in deiner Nähe.',
          rules:
            'Die Admins von Pupspace arbeiten hart daran, unsere Community so inklusiv und einladend wie möglich zu halten. Illegale Aktivitäten, Trolling, Belästigung, Rassismus, Misogynie, Homophobie, Transphobie, Ableismus sowie öffentliche Zurschaustellung von Nacktheit oder sexuellen Handlungen sind auf Pupspace streng verboten.',
          welcome:
            'Unsere Admins sind für dich da! Wenn du eine Frage oder ein Anliegen hast, zögere nicht, ein Support-Ticket zu eröffnen oder uns eine E‑Mail zu senden.\n\nWillkommen in deinem neuen Zuhause! *wags*\n\nDas Pupspace-Team',
        },
      },
    },
  },
  communities: {
    myCommunities: 'Meine Communities',
  },
  PostType: {
    ChangedLocation: 'Hat ihren Standort geändert zu: {{text}}',
    ChangedNickname: 'Hat ihren Benutzernamen geändert: {{text}}',
    ChangedRelStatus: 'Hat ihren Beziehungsstatus geändert',
    ChangedWeight: 'Hat ihr Gewicht auf {{newWeight}} geändert, eine Zunahme von {{newWeightDiff}}',
    NewMember: 'Ist {{communityName}} beigetreten',
    NewPhoto: 'Hat ein neues Foto gepostet',
    NewEvent: 'Hat eine neue Veranstaltung gepostet: ',
    NotifyNewComment: {
      post: 'hat einen Beitrag kommentiert',
      photo: 'hat ein Foto kommentiert',
    },
    NotifyNewFollow: 'folgt dir jetzt',
    NotifyNewWallToWall: 'hat auf deine Pinnwand gepostet',
    NotifyPhotoLike: 'hat dein Foto geliked',
    NotifyUnlocked: 'hat dir Zugang zu ihren privaten Fotos gewährt',
    NotifyUnlockRequest: 'bittet um Zugang zu deinen privaten Fotos',
  },
  TransactionType: {
    Admin: 'Admin {{premium}} Pass',
    Adjustment: 'Anpassung',
    BOGO: '{{premium}} Promotion (Kauf eins, bekomm eins gratis)',
    Courtesy: 'Kostenloser {{premium}} Pass',
    DonationWithPaypal: 'Spende, vielen Dank! (bezahlt mit PayPal)',
    FoundingMember: 'Gründungsmitglied {{premium}} Pass',
    GiftCertificatePaidFor: '{{premium}} Geschenkgutschein Kauf',
    GiftCertificateRedeemed: '{{premium}} Geschenkgutschein eingelöst',
    PaidByMail: '{{premium}} Pass Kauf (bezahlt mit Bargeld/Scheck/Zahlungsanweisung)',
    PaidWithApple: '{{premium}} Abonnement (bezahlt mit Apple App Store)',
    PaidWithCCBill: '{{premium}} Abonnement (bezahlt mit CCBill)',
    PaidWithGoogle: '{{premium}} Abonnement (bezahlt mit Google Play)',
    PaidWithPaypal: '{{premium}} Pass Kauf (bezahlt mit PayPal)',
    PaidWithStripe: '{{premium}} Abonnement (bezahlt mit Stripe)',
    Referrals: '{{premium}} Zeit durch Empfehlungen verdient',
    Refund: 'Gutschrift/Rückerstattung',
    Trial: 'Gratis {{premium}} Testversion',
  },

  ProfileTags: {
    BodyFeatures: {
      Armpits: 'Achselhöhlen',
      ArmsLegs: 'Arme/Beine',
      Asses: 'Hintern',
      Athletic: 'Athletisch',
      Average: 'Durchschnittlich',
      Balbo: 'Balbo',
      BallBelly: 'Kugelbauch',
      Beard: 'Bart',
      Beards: 'Bärte',
      Bellies: 'Bäuche',
      BellyButtons: 'Bauchnabel',
      BodyMods: 'Körpermodifikation',
      Breasts: 'Brüste (weiblich)',
      BreastsFemale: 'Brüste (weiblich)',
      BreastsMale: 'Brüste (männlich)',
      ChestPecs: 'Brustmuskeln',
      ChinStrap: 'Kinnriemen-Bart',
      Chubby: 'Rundlich überall',
      Chubby2: 'Mollig',
      ChubbyBelly: 'Mollig mit Bauch',
      ChunkyMuscle: 'Kräftige Muskeln',
      Curvy: 'Kurvig',
      Feet: 'Füße',
      First30: 'Erste 30 Pfund',
      FullBeard: 'Vollbart',
      Goatee: 'Ziegenbart',
      Hairy: 'Behaart',
      Hands: 'Hände',
      Husky: 'Stämmig',
      LightBeard: 'Leichter Bart',
      LoveHandles: 'Hüftspeck',
      ManTits: 'Männerbrüste',
      Moustache: 'Schnurrbart',
      MuscleGut: 'Muskeln und Bauch',
      Muscular: 'Muskulös',
      MuttonChops: 'Koteletten',
      Nipples: 'Brustwarzen',
      None: 'Keine',
      PearChubby: 'Birnenförmig mollig',
      PencilThin: 'Dünner Schnurrbart',
      Piercings: 'Piercings',
      SlightlyChubby: 'Leicht mollig',
      Slim: 'Schlank',
      Smooth: 'Glatt',
      SomeHair: 'Etwas Behaarung',
      SuperChub: 'Super Chub',
      SuperChubby: 'Super Chubby',
      Tattoos2: 'Tattoos',
      ThickCurvy: 'Kräftig/kurvig',
      Thin: 'Dünn',
      Toned: 'Definierte Muskeln',
      Trimmed: 'Gestutzt',
      VanDyke: 'Van Dyke',
      VeryChubby: 'Sehr mollig',
      VeryHairy: 'Sehr behaart',
    },
    Other: {
      AfterCare: 'Nachsorge',
      Agender: 'Agender',
      AgePlay: 'Age Play',
      AnalPlayBottom: 'Anal (passiv)',
      AnalPlayTop: 'Anal (aktiv)',
      Androgynous: 'Androgyn',
      Asexuality: 'Asexualität',
      Babyfur: 'DiaperFur',
      BalloonPlay: 'Ballonspiel',
      Bathing: 'Baden/Duschen',
      BDSM: 'BDSM',
      Belching: 'Rülpsen',
      BellyPlay: 'Bauchspiel',
      BellyRubs: 'Bauch reiben',
      Biting: 'Beißen',
      BitsGags: 'Bits/Knebel',
      Bloating: 'Bloating',
      Blueberry: 'Blaubeere',
      BodyOdors: 'Duft/Körpergeruch',
      Bodypaint: 'Körperbemalung',
      BodyWorship: 'Körperverehrung',
      Bondage: 'Bondage/Dominanz',
      Bondage2: 'Bondage',
      Boots: 'Stiefel',
      BootsHeels: 'Stiefel & High Heels',
      BootsWorship: 'Stiefel/Stiefelverehrung',
      BowlEating: 'Aus einer Schüssel essen',
      Brats: 'Brats',
      BreastGrowth: 'Brustwachstum',
      BreathPlay: 'Atemspiel',
      Burping: 'Rülpsen',
      Businessmen: 'Geschäftsmänner',
      ButtplugsDildos: 'Buttplugs/Dildos',
      CageSleep: 'Im Käfig schlafen',
      CBT: 'CBT',
      Chastity: 'Keuschheit',
      Cigars: 'Zigarren/Pfeifen/Tabak',
      CollaredOwned: 'Mit Halsband/Besessen',
      Complicated: 'Es ist kompliziert',
      Control: 'Kontrolle',
      CrossDress: 'Cross-Dressing',
      Cuckolding: 'Cuckolding',
      Cuddling: 'Kuscheln/Frottage',
      CunnGiver: 'Cunnilingus (geben)',
      CunnReceiver: 'Cunnilingus (empfangen)',
      DaddySon: 'Daddy-Sohn Rollenspiel',
      Dating: 'Dating',
      DatingBreak: 'Pause vom Dating',
      Diapers: 'AB/DL',
      DirtyFur: 'Dirtyfur',
      DirtyTalking: 'Dirty Talk',
      Discipline: 'Disziplin/Bestrafungen',
      DoctorPatient: 'Arzt-Patient Rollenspiel',
      Dogshow: 'Hundeschau',
      Domination: 'Dominanz',
      DomSub: 'Dominanz/Unterwerfung',
      EdgePlay: 'Edge Play',
      EdgingOrgasm: 'Edging/Orgasmuskontrolle',
      Engaged: 'Verlobt',
      EStim: 'Elektrostimulation',
      Exhibitionism: 'Exhibitionismus/Öffentlicher Sex',
      ExplodBellies: 'Explodierende Bäuche',
      FaceSitting: 'Gesichtssitzen',
      Farting: 'Furzen',
      Feedee: 'Feedee',
      Feeder: 'Feeder',
      FeedingFeedee: 'Feeding (empfangen)',
      FeedingFeeder: 'Feeding (geben)',
      Female: 'Frau',
      Feminine: 'Feminin',
      Fighting: 'Ringen/Kämpfen',
      Fingering: 'Fingern',
      Fisting: 'Fisting',
      FistingBottom: 'Fisting (passiv)',
      FistingTop: 'Fisting (aktiv)',
      Flogging: 'Auspeitschen/Peitschen',
      FootWorship: 'Fußverehrung',
      ForceFeeding: 'Zwangsfütterung',
      Furries: 'Furries',
      Fursuit: 'Fursuit',
      Gaining: 'Zunehmen/Ermutigen',
      GainingInstant: 'Sofortige Gewichtszunahme',
      GainingLT: 'Langfristige Gewichtszunahme',
      Gassy: 'Blähungen',
      Genderfluid: 'Genderfluid',
      GenderNonconforming: 'Gender-Nonconforming',
      GenderShifting: 'Geschlechtswandel',
      GroupSex: 'Gruppensex',
      GrowUnhealthy: 'Ungesund zunehmen',
      Gunge: 'Schleim',
      GutPunch: 'Bauchschläge',
      HandJob: 'Handjob',
      HandlerTrainer: 'Handler/Trainer',
      HandsfreeOrgasm: 'Freihändiger Orgasmus',
      HeatEstrus: 'Hitze/Brunst',
      Heels: 'High Heels',
      Humiliation: 'Demütigung',
      Hypnosis: 'Hypnose',
      Hypnotization: 'Hypnose',
      Immobility: 'Zunehmen bis zur Immobilität',
      Inflation: 'Inflation',
      Intersex: 'Intersex',
      InTraining: 'In Ausbildung',
      KennelSleep: 'Im Korb/Zwinger schlafen',
      Kissing: 'Küssen',
      KnotPlay: 'Knotenspiel/Verknoten',
      Latex: 'Latex',
      LeashWalk: 'An der Leine gehen',
      Leather: 'Leder',
      Licking: 'Lecken',
      Lipstick: 'Fingernägel & Lippenstift',
      Lycantropy: 'Lykanthropie',
      Lycra: 'Lycra',
      MacroMicro: 'Makro/Mikro Fantasien',
      Male: 'Mann',
      MalePreg: 'Mpreg (männliche Schwangerschaft)',
      ManScent: 'Männergeruch/Körpergeruch',
      Married: 'Verheiratet',
      Masculine: 'Maskulin',
      Masochism: 'Masochismus',
      Mature: 'Reife/ältere Partner',
      Measuring: 'Messen/Wiegen',
      Men: 'Männer',
      MessyEat: 'Unordentliches Essen',
      MessyEating: 'Unordentliches Essen/Schweinespiel',
      MicroPenis: 'Mikropenis',
      Military: 'Militär',
      Monogamous: 'Monogam',
      MpregBirthing: 'Mpreg/Geburt',
      Murrsuit: 'Murrsuit',
      MuscleGrow: 'Muskelwachstum',
      MuscleWorship: 'Muskelverehrung',
      Musk: 'Moschus',
      MutualMasturb: 'Gegenseitige Masturbation',
      Muzzles: 'Maulkörbe',
      Neoprene: 'Neopren',
      NipplePlay: 'Brustwarzenstimulation',
      NonBinary: 'Non-binär',
      NonSexPupPlay: 'Nicht-sexuelles Pup Play',
      Obedience: 'Gehorsamstraining/Befehle',
      OlderMen: 'Reife/ältere Männer',
      OpenPolyRelation: 'In einer offenen Poly-Beziehung',
      OpenRelationship: 'In einer offenen Beziehung',
      OralBottom: 'Oral (passiv)',
      OralPlayBottom: 'Oral (geben)',
      OralPlayTop: 'Oral (empfangen)',
      OralTop: 'Oral (aktiv)',
      Other: 'Andere',
      Oviposition: 'Eiablage',
      Owner: 'Besitzer',
      Pack: 'In einem Rudel',
      Padding: 'Polsterung',
      Pegging: 'Pegging',
      Petting: 'Kratzen/Streicheln',
      PigPlay: 'Pig Play',
      PissPlay: 'Natursektspiele/Wassersport',
      Plugtail: 'Plugschwanz',
      Plush: 'Plüsch',
      Polyamorous: 'Poly',
      PolyRelation: 'In einer Poly-Beziehung',
      Pregnancy: 'Schwangerschaft',
      Primal: 'Primal',
      PublicSex: 'Öffentlicher Sex/Voyeurismus',
      Punks: 'Punks',
      PupGear: 'Pup-Ausrüstung',
      PupPlay: 'Pup Play',
      PuppyGames: 'Pup spiele (Apportieren, Bällebad)',
      PuppyToys: 'Pupspielzeug',
      Queer: 'Queer',
      Relationship: 'In einer Beziehung',
      Rimming: 'Rimming',
      RimmingGiver: 'Rimming (geben)',
      RimmingReceiver: 'Rimming (empfangen)',
      RolePlay: 'Rollenspiel',
      Rubber: 'Gummi',
      RubberLatexLeather: 'Gummi/Latex/Leder',
      Sadism: 'Sadismus',
      SadoMaso: 'Sadismus/Masochismus',
      Saline: 'Kochsalzlösung',
      Scat: 'Scat',
      SciFiGain: 'Science-Fiction Gewichtszunahme',
      Scratching: 'Kratzen',
      SensoryDep: 'Sinnesentzug',
      SexualCanineRole: 'Sexuelle Hunde-Rolle',
      SheathPlay: 'Vorhautspiel',
      Single: 'Single',
      Skinheads: 'Skinheads',
      Smashing: 'Zerdrücken/Zermalmen',
      SmashingSitting: 'Zerdrücken/Auf jemanden setzen',
      Sniffing: 'Schnüffeln',
      Sounding: 'Sounding/Katheter',
      Spanking: 'Spanking',
      SpeciesSpecific: 'Artspezifisch',
      Speedos: 'Speedos/Lycra',
      Sportswear: 'Sportkleidung',
      Squashing: 'Zerquetschen',
      StraightMen: 'Hetero/verheiratete Männer',
      Stray: 'Streuner',
      StretchMarks: 'Dehnungsstreifen',
      Stuffing: 'Vollstopfen',
      Submission: 'Unterwerfung',
      Suits: 'Anzüge',
      Swinging: 'Swinging & Gruppensex',
      TailPulling: 'Schwanz ziehen',
      Tattoos: 'Tattoos/Piercings',
      Teasing: 'Necken',
      TeasingPublic: 'Necken/Öffentliche Demütigung',
      Technophilia: 'Technophilie',
      Tentacles: 'Tentakel',
      Tickling: 'Kitzeln',
      TightClothes: 'Enge Kleidung/Platzende Knöpfe',
      Toons: 'Toons',
      Toys: 'Spielzeug/Dildos',
      Trans: 'Transsexuelle/Intersexuelle',
      Transformation: 'Transformation',
      Transgender: 'Transgender',
      TransMan: 'Trans Mann',
      TransMen: 'Trans Männer',
      TransWoman: 'Trans Frau',
      TransWomen: 'Trans Frauen',
      Treats: 'Leckerlis/Belohnungen',
      TwoSpirit: 'Two-Spirit',
      Uncle: 'Onkel/Vater/Cousin Fantasien',
      UncollaredUnowned: 'Ohne Halsband/Ohne Besitzer',
      UnderConsideration: 'In Überlegung',
      Underwear: 'Unterwäsche',
      Uniforms: 'Uniformen',
      VacantKennel: 'Freier Zwinger',
      VacBed: 'Vakuumbett/Schlafsäcke',
      Vanilla: 'Vanilla/Kuscheln',
      VetRoleplay: 'Tierarzt-Haustier Rollenspiel',
      Vore: 'Vore',
      VoyeurExhib: 'Voyeurismus & Exhibitionismus',
      Voyeurism: 'Voyeurismus',
      WaterSports: 'Wassersport',
      WaxPlay: 'Wachsspiel',
      WeightGain: 'Gewichtszunahme',
      Wet: 'Nass-Look/Nasse Jeans',
      Widowed: 'Verwitwet',
      Women: 'Frauen',
      Wrestling: 'Ringen/Singlets',
    },
    SocialTags: {
      Admirer: 'Admirer',
      Alpha: 'Alpha',
      Amphibian: 'Amphibium',
      Aquatic: 'Wassertier',
      Avian: 'Vogel',
      BBW: 'Big Beautiful Woman',
      Bear: 'Bär',
      BearSpecie: 'Bär',
      Beta: 'Beta',
      BHM: 'Big Handsome Man',
      Bloater: 'Bloater',
      Bovid: 'Rind',
      Boy: 'Junge',
      Bull: 'Bulle',
      Canid: 'Hund',
      Cervid: 'Hirsch',
      CatKitten: 'Katze/Kätzchen',
      Chaser: 'Chaser',
      Chub: 'Chub',
      Chub4Chub: 'Chub4Chub',
      ChubbyBear: 'Molliger Bär',
      Cub: 'Cub',
      Daddy: 'Daddy',
      Dog: 'Hund',
      Dominant: 'Dom',
      Dragon: 'Drache',
      Encourager: 'Encourager',
      Exotic: 'Exotisch',
      FA: 'Fat Admirer',
      Feedee: 'Feedee',
      Feeder: 'Feeder',
      FelineLarge: 'Katze (groß)',
      FelineSmall: 'Katze (klein)',
      Fox: 'Fuchs',
      FriendOfPups: 'Pup Freund',
      Gainer: 'Gainer',
      HandlerTrainer: 'Handler/Trainer',
      Horse: 'Pferd',
      HorsePony: 'Pferd/Pony',
      Hybrid: 'Hybrid',
      Maintainer: 'Maintainer',
      Marsupial: 'Beuteltier',
      Master: 'Master',
      Mistress: 'Mistress',
      Mommy: 'Mommy',
      MuscleGainer: 'Muskel-Gainer',
      Omega: 'Omega',
      Otter: 'Otter',
      OtherMammal: 'Anderes (Säugetier)',
      OtherSpecie: 'Andere',
      Panda: 'Panda',
      PetOther: 'Haustier (Andere)',
      Primate: 'Primat',
      Pup: 'Pup',
      Rabbit: 'Kaninchen',
      Raccoon: 'Waschbär',
      Reptilian: 'Reptil',
      Rodent: 'Nagetier',
      Sir: 'Sir',
      Skunk: 'Stinktier',
      Slave: 'Sklave',
      Submissive: 'Sub',
      Switch: 'Switch',
      Wolf: 'Wolf',
    },
    Languages: {
      Arabic: 'Arabisch',
      Bulgarian: 'Bulgarisch',
      Chinese: 'Chinesisch',
      Czech: 'Tschechisch',
      Danish: 'Dänisch',
      Dutch: 'Niederländisch',
      English: 'Englisch',
      Filipino: 'Filipino',
      Finnish: 'Finnisch',
      French: 'Französisch',
      German: 'Deutsch',
      Greek: 'Griechisch',
      Hebrew: 'Hebräisch',
      Hindi: 'Hindi',
      Hungarian: 'Ungarisch',
      Indonesian: 'Indonesisch',
      Italian: 'Italienisch',
      Japanese: 'Japanisch',
      Korean: 'Koreanisch',
      Norwegian: 'Norwegisch',
      Others: 'Andere',
      Persian: 'Persisch',
      Polish: 'Polnisch',
      Portuguese: 'Portugiesisch',
      Romanian: 'Rumänisch',
      Russian: 'Russisch',
      SerboCroatian: 'Serbokroatisch',
      Sign: 'Gebärdensprache',
      Slovak: 'Slowakisch',
      Spanish: 'Spanisch',
      Swedish: 'Schwedisch',
      Thai: 'Thailändisch',
      Turkish: 'Türkisch',
      Ukranian: 'Ukrainisch',
      Urdu: 'Urdu',
      Vietnamese: 'Vietnamesisch',
    },
    Interests: {
      AddPackMembers: 'Mein Rudel erweitern',
      Alpha: 'Alpha',
      AsexualRelationship: 'Asexuelle Beziehung',
      BdsmDynamic: 'BDSM-Dynamik',
      Beta: 'Beta',
      Boy: 'Junge',
      Collaring: 'Halsband',
      Daddy: 'Daddy',
      Date: 'Date',
      Dominant: 'Dom',
      Exploration: 'Einführung/Erkundung',
      FormPack: 'Neues Rudel bilden',
      Friends: 'Freunde',
      Gaming: 'Gaming',
      HandlerTrainer: 'Handler/Trainer',
      Hookup: 'Gelegenheitsbegegnung',
      JoinPack: 'Bestehendem Rudel beitreten',
      Master: 'Master',
      Mistress: 'Mistress',
      Mommy: 'Mommy',
      Moshes: 'Pup Moshes/Events',
      NonSexualPlaymates: 'Nicht-sexuelle Spielpartner',
      Omega: 'Omega',
      OnlineChat: 'Online chatten',
      OnlineVideo: 'Online Video (Cam2Cam)',
      PolyRelation: 'Poly-Beziehung',
      PolyRelationship: 'Poly-Beziehung',
      Relationship: 'Beziehung',
      RoleplayPartner: 'Rollenspiel-Partner',
      RomanticPartner: 'Romantischer Partner',
      Sex: 'Gelegenheitsbegegnung',
      SexPartner: 'Regelmäßiger intimer Partner',
      Sir: 'Sir',
      Slave: 'Sklave',
      Submissive: 'Sub',
      Switch: 'Switch',
      Training: 'Training',
      VideoChat: 'Video-Chat',
    },
    Ethnicities: {
      Arab: 'Naher Osten/Nordafrika',
      Asian: 'Ostasiatisch',
      Black: 'Schwarz/Afrikanischer Abstammung',
      Hispanic: 'Hispanisch/Latinx',
      Mixed: 'Gemischt/Multi',
      Native: 'Amerikanische Ureinwohner/Indigene',
      Pacific: 'Pazifische Inseln',
      SouthAsian: 'Südasiatisch',
      White: 'Weiß/Kaukasisch',
    },
  },
};
